export default {
      id: "dot_scales-usage",
      viewBox: "0 0 33 26",
      url: __webpack_public_path__ + "img/icons.svg#dot_scales",
      toString: function () {
        return this.url;
      }
    }